import React, { Component } from "react";
import { propertyUtil } from "views/Pma/PropertyUtil";
import moment from "moment";

class MarketSaleRow extends Component {
  formatAddressName(address, agentListing) {
    function capitalizeFirstLetter(word) {
      if ((word && word.length < 5) || (word && word.includes("#"))) {
        return word;
      } else {
        word = word.toLowerCase();
        const firstLetter = word.charAt(0);
        const firstLetterCap = firstLetter.toUpperCase();
        const remainingLetters = word.slice(1);
        const capitalizedWord = firstLetterCap + remainingLetters;

        return capitalizedWord;
      }
    }

    let split = address.split(" ");
    let mappedSplit = split.map((name) => {
      let isAllUpperCase = name === name.toUpperCase();

      if (isAllUpperCase) {
        return capitalizeFirstLetter(name);
      }
      return name;
    });
    return mappedSplit.join(" ");
  }
  getMonthAndYearString = (inputTime) => {
    try {
      let month = moment(inputTime).format("MMM");
      let day = moment(inputTime).format("D");
      let year = moment(inputTime).format("YY");

      return (
        <div className="date-td">
          <div>{month}</div>
          <div>{day},</div>
          <div>{year}</div>
        </div>
      );
      // return moment(inputTime).format("MMM D, YYYY");
    } catch (err) {
      return "";
    }
  };

  calculatePricePerSqft(calculation, saleP, sqft) {
    if (calculation === "-") {
      let res = Math.round(saleP / sqft);
      return res.toLocaleString();
    } else {
      return Math.round(calculation).toLocaleString();
    }
  }

  render() {
    const {
      formatBaths,

      propTypeAcronym,
      shortenStatus,
    } = propertyUtil;

    const { solds, mlsAreaID, older, isSingleTable, agentData } = this.props;
    const { listgenUserID } = agentData;
    let isGailPearl = listgenUserID === "103455";
    let isCountryClubGate = mlsAreaID === "132" ? true : false;

    const listMap =
      solds &&
      solds.map((list, i) => {
        let isAgentListing =
          list.isAgentFiltered === true || list.status === "Coming Soon";

        if (isGailPearl) {
          isAgentListing = false;
          if (list.streetName === "Moreton Bay" && list.streetSuffix === "-") {
            list.streetSuffix = "Lane";
          }
        }
        if (
          list.streetNumber === "51" &&
          list.streetName === "Six Flags" &&
          list.streetSuffix === "Cir" &&
          listgenUserID === "100661"
        ) {
          isAgentListing = true;
        }
        if (
          listgenUserID === "102627" &&
          list.streetNumber === "4840" &&
          list.streetName === "Anna" &&
          list.streetSuffix === "Dr"
        ) {
          isAgentListing = false;
        }
        let extraDisclaimer = false;
        if (
          mlsAreaID === "SMA-470" &&
          list.streetNumber === "2533" &&
          list.streetName === "Hayward" &&
          list.streetSuffix === "Dr"
        ) {
          extraDisclaimer = true;
        }
        let isAnnetteVait = listgenUserID === "101001";
        let isKristinArntz = listgenUserID === "100462";
        let isShawnaSpaulding = listgenUserID === "100210";
        let showAddressNumber =
          list.status === "Sold" ||
          isAgentListing ||
          isAnnetteVait ||
          isKristinArntz ||
          isGailPearl ||
          isShawnaSpaulding;

        let hasUnitNum =
          !isCountryClubGate &&
          (list.propertyType === "Townhouse" ||
            list.propertyType === "Condominium" ||
            list.propertyType === "Condo/Co-Op") &&
          list.unitNumber !== "-";

        let addressName = "";
        let isJulieFlouty651Columbia =
          listgenUserID === "106421" &&
          list.streetNumber === "651" &&
          list.streetName === "Columbia";

        if (isJulieFlouty651Columbia) {
          showAddressNumber = false;
        }

        if (
          list.streetNumber !== "-" &&
          list.streetNumber !== "0" &&
          list.streetNumber !== "." &&
          showAddressNumber &&
          !isJulieFlouty651Columbia
        ) {
          addressName += list.streetNumber;
        }
        if (
          isGailPearl == "x" &&
          list.streetNumber === "x5800" &&
          list.streetName === "Encina Road #3"
        ) {
          addressName += ` Encina, #3`;
        } else {
          addressName += ` ${list.streetName}`;
        }

        if (list.streetSuffix && list.streetSuffix !== "-") {
          addressName += ` ${list.streetSuffix}`;
        }
        if (hasUnitNum && showAddressNumber) {
          let comma = ",";
          if (isGailPearl) {
            comma = "";
          }

          if (list.unitNumber.includes("Unit")) {
            if (
              isGailPearl == "x" &&
              list.streetName == "xEncina" &&
              list.streetNumber === "5940" &&
              list.unitNumber == "Unit 1"
            ) {
              addressName += ", #1";
            } else {
              addressName += `${comma} ${list.unitNumber}`;
            }
          } else if (list.unitNumber.includes("#")) {
            addressName += `${comma} ${list.unitNumber}`;
          } else {
            addressName += `${comma} #${list.unitNumber}`;
          }
        }

        let soldDisclaimer = false;

        let domDisclaimer = false;
        if (mlsAreaID === "SMA-470") {
          let has1556BernalAve =
            list.streetNumber === "1556" &&
            list.streetName === "Bernal" &&
            list.streetSuffix === "Ave";

          if (has1556BernalAve) {
            domDisclaimer = true;
          }
        }
        let addressSize = addressName.length > 25 ? "smaller-row-address" : "";
        let is2238NolaDr =
          list.streetNumber === "2238" &&
          list.streetName === "Nola" &&
          listgenUserID === "105016";
        if (
          isGailPearl &&
          list.streetNumber === "250" &&
          list.streetName === "N, Fairview Avenue #6"
        ) {
          addressName = `250 N. Fairview Avenue #6`;
        } else if (
          isGailPearl &&
          list.streetNumber === "320" &&
          list.streetName === "Fairview"
        ) {
          addressName = `320 Fairview Avenue #5`;
        } else if (
          isGailPearl &&
          list.streetNumber === "340" &&
          list.streetName === "Fairview"
        ) {
          addressName = `340 Fairview Avenue #2`;
        }

        // if (is2238NolaDr) {
        //   //list.status = "Pending";
        // }
        // if (
        //   isGailPearl &&
        //   list.streetNumber === "5940" &&
        //   list.streetName === "Encina Road #4"
        // ) {
        //   addressName = `5940 Encina Road, #4`;
        // } else if (
        //   isGailPearl &&
        //   list.streetNumber === "5800" &&
        //   list.streetName === "Encina Road #3"
        // ) {
        //   addressName = `5800 Encina Road, #3`;
        // } else if (
        //   isGailPearl &&
        //   list.streetNumber === "5940" &&
        //   list.streetName === "Encina" &&
        //   list.streetSuffix === "Road" &&
        //   list.unitNumber === "Unit 1"
        // ) {
        //   addressName = `5940 Encina Road, #1`;
        // } else if (
        //   isGailPearl &&
        //   list.streetNumber === "327" &&
        //   list.streetName === "Moreton Bay Lane #3"
        // ) {
        //   addressName = `327 Moreton Bay Lane, #3`;
        // } else if (
        //   isGailPearl &&
        //   list.streetNumber === "250" &&
        //   list.streetName === "N, Fairview Avenue #6"
        // ) {
        //   addressName = `250 N. Fairview Avenue, #6`;
        // } else if (
        //   isGailPearl &&
        //   list.streetNumber === "320" &&
        //   list.streetName === "Fairview"
        // ) {
        //   addressName = `320 Fairview Avenue, #5`;
        // }
        let coListingDisclaimer = false;

        let coListing710FrenchmansDisclaimer = false;
        if (
          listgenUserID === "102527" &&
          list.streetNumber === "710" &&
          list.streetName === "Frenchmans"
        ) {
          coListing710FrenchmansDisclaimer = true;
        }
        if (
          listgenUserID === "102527" &&
          list.streetNumber === "855" &&
          list.streetName === "Allardice"
        ) {
          coListing710FrenchmansDisclaimer = true;
        }

        let buyersAgentDisclaimer;

        if (
          mlsAreaID === "SMA-429" &&
          list.streetNumber === "721" &&
          list.streetName === "Linda" &&
          list.streetSuffix === "CT"
        ) {
          buyersAgentDisclaimer = true;
        }
        let useComingSoon;
        if (
          list.streetNumber === "4686" &&
          list.streetName === "Herrin Way" &&
          listgenUserID === "107253"
        ) {
          useComingSoon = true;
          isAgentListing = true;
        }

        let is3650LockeCt =
          list.streetNumber === "3650" &&
          list.streetName === "Locke Ct" &&
          listgenUserID === "107253";

        if (
          listgenUserID === "107253" &&
          list.streetName === "Benedict Ct" &&
          list.streetNumber === "1398"
        ) {
          console.log("inside", list);
          list.bedBaths = "5/5.5";
        }
        return (
          <tr
            key={`${list.address} ${list.listPrice} ${list.saleDate} ${i}`}
            className={`${list.status && list.status.toLowerCase()} ${
              older ? "presolds-row" : "recent-row"
            } ${isSingleTable ? "single-table-row" : ""} ${
              isAgentListing ? "highlight-agent-listing" : ""
            }`}
          >
            {useComingSoon || list.status === "Coming Soon" ? (
              <td
                // className={`status-text`}
                className={`status-text coming`}
                align="left"
              >
                {(list.isOffMarketSale === "1" || soldDisclaimer) && (
                  <strong className="off-market-asterisk">*</strong>
                )}

                <p>
                  {domDisclaimer && (
                    <strong className="extra-disclaimer-asterisk">* </strong>
                  )}
                  {extraDisclaimer && (
                    <strong className="extra-disclaimer-asterisk">** </strong>
                  )}
                </p>

                <div>
                  <p>Coming</p>
                  <p>Soon</p>
                </div>
              </td>
            ) : (
              <td
                // className={`status-text`}
                className={`status-text ${
                  list.status && list.status.toLowerCase()
                }`}
                align="left"
              >
                <p>
                  {(list.isOffMarketSale === "1" || soldDisclaimer) && (
                    <strong className="off-market-asterisk">*</strong>
                  )}
                  {coListingDisclaimer && (
                    <strong className="extra-disclaimer-cl">cl </strong>
                  )}

                  {coListing710FrenchmansDisclaimer && (
                    <strong
                      className={`extra-disclaimer-star-cl ${list.status}-disclaimer`}
                    >
                      *cl{" "}
                    </strong>
                  )}

                  {buyersAgentDisclaimer && (
                    <strong
                      className={`extra-disclaimer-asterisk ${list.status}-extra-asterisk`}
                    >
                      *{" "}
                    </strong>
                  )}

                  {domDisclaimer && (
                    <strong className="extra-disclaimer-asterisk">* </strong>
                  )}
                  {extraDisclaimer && (
                    <strong className="extra-disclaimer-asterisk">** </strong>
                  )}

                  {shortenStatus(list.status, "pendingOnly", true)}
                </p>
              </td>
            )}

            {list.saleDate === "-" ? (
              <td></td>
            ) : (
              <td className="market-table-sale-date-row">
                {this.getMonthAndYearString(list.saleDate)}
              </td>
            )}

            <td className="prop-type-text">
              {propTypeAcronym(list.propertyType)}
            </td>
            <td>
              <p className={addressSize}>
                {/*{list.isOffMarketSale == "1" && (
                  <strong className="asterisk">*</strong>
                )}*/}
                {this.formatAddressName(addressName)}
              </p>
            </td>
            <td>
              {list.status === "Coming Soon" ? (
                <div className="off-centered-dash">
                  <p>TBD</p>
                </div>
              ) : list.listPrice === "-" ? (
                <div className="off-centered-dash">
                  <p>—</p>
                </div>
              ) : (
                <div>
                  <p>$</p>
                  <p>{Number(list.listPrice).toLocaleString()}</p>
                </div>
              )}
            </td>

            <td>
              {listgenUserID === "100567" &&
              list.streetNumber === "3233" &&
              list.streetName === "Cliff" &&
              list.status === "Sold" ? (
                <div>
                  <p>$</p>
                  <p>11,000,000</p>
                </div>
              ) : list.salePrice === "-" ? (
                <div className="off-centered-dash">
                  <p>—</p>
                </div>
              ) : (
                <div>
                  {/*{list.isOffMarketSale == "1" && (
                    <strong className="asterisk">*</strong>
                  )}*/}
                  <p>$</p>
                  <p>{Number(list.salePrice).toLocaleString()}</p>
                </div>
              )}
            </td>
            {list.isOffMarketSale === "1" &&
            (list.daysOnMarket === "0" || list.daysOnMarket === "-") ? (
              <td>
                <div className="off-centered-dash">
                  <p>—</p>
                </div>
              </td>
            ) : (
              <td>{list.daysOnMarket}</td>
            )}

            <td>{formatBaths(list.bedBaths, true).bed}</td>
            <td>
              {is3650LockeCt
                ? "3.5"
                : formatBaths(list.bedBaths, true, true).bath}
            </td>
            <td>
              {list.squareFeet === "-" || list.squareFeet === "0" ? (
                <p>N/A</p>
              ) : (
                <p>{Math.round(list.squareFeet).toLocaleString()}</p>
              )}
            </td>
          </tr>
        );
      });
    return <tbody>{listMap}</tbody>;
  }
}

export default MarketSaleRow;
